export default __webpack_public_path__ + "static/media/chef.c9e05311.png";